import { io, type Socket } from 'socket.io-client'
import { useAuthStore } from '../stores/useAuthStore.js'

let socket: Socket | null = null

export function getSocket(): Socket | null {
  return socket
}

export function connectSocket(): Socket {
  if (socket?.connected) return socket

  const tokens = useAuthStore.getState().tokens
  if (!tokens) throw new Error('Cannot connect socket without auth tokens')

  socket = io({
    auth: {
      accessToken: tokens.accessToken,
      client: tokens.client,
      uid: tokens.uid,
    },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  })

  return socket
}

export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}
